<template>
  <v-dialog v-model="dialog" scrollable width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        title="Innstillinger"
        aria-label="Innstillinger"
        text
        background-color="transparent"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon class="mr-2">mdi-cog-outline</v-icon>Innstillinger
      </v-btn>
    </template>
    <v-card>
      <v-card-text class="pa-4">
        <h2 class="text-h5">Innstillinger</h2>
        <p>
          Her kan du endre innstillingene til NVE Seriekart. Endringene trer i
          kraft umiddelbart når du klikker Lagre-knappen nederst i dialogboksen.
        </p>
        <h3 class="mt-2">Symbolisering</h3>
        <v-row class="pl-3 pr-4">
          <v-select
            autofocus
            v-model="selectedSymbolColor"
            filled
            :items="symbolColors"
            label="Velg hvilken farge som skal brukes i symboliseringen."
            class="mb-2 mt-4"
            dense
          ></v-select>
        </v-row>
        <v-row class="pl-3 pr-4">
          <v-select
            v-model="selectedSymbolSize"
            filled
            return-object
            :items="symbolSizes"
            class="mb-2 mt-4"
            label="Velg symbolstørrelse"
            dense
          ></v-select>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-card-actions>
          <v-btn text @click="dialog = false">Avbryt</v-btn>

          <v-btn color="primary" text @click="updateLayerRenderer">Lagre</v-btn>
        </v-card-actions>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "AppSettingsDialog",
  data() {
    return {
      dialog: false,
      selectedSymbolColor: "#448eff",
      selectedSymbolSize: {
        text: "Normal",
        value: 8,
        labelSize: 10,
        yOffset: 20,
      },
      symbolColors: [
        {
          text: "Rød",
          value: "#F44336",
        },
        {
          text: "Grønn",
          value: "#4CAF50",
        },
        {
          text: "Blå (standard)",
          value: "#448eff",
        },
        {
          text: "Rosa",
          value: "#E91E63",
        },
        {
          text: "Gul",
          value: "#FFEB3B",
        },
        {
          text: "Svart",
          value: "#000000",
        },
      ],
      symbolSizes: [
        {
          text: "Normal",
          value: 8,
          labelSize: 10,
          yOffset: 20,
        },
        {
          text: "Større",
          value: 20,
          labelSize: 12,
          yOffset: 25,
        },
        {
          text: "Størst",
          value: 26,
          labelSize: 14,
          yOffset: 30,
        },
      ],
    };
  },
  computed: {
    ...mapState(["mainLayerSymbolSettings"]),
  },
  methods: {
    ...mapActions(["setMainLayerSymbolSettings"]),
    updateLayerRenderer: function() {
      this.setMainLayerSymbolSettings({
        color: this.selectedSymbolColor,
        size: this.selectedSymbolSize,
      });
      this.dialog = false;
    },
  },
};
</script>
<style></style>
